var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('wx-open-launch-app',{staticClass:"wx-open-launch-app-container",attrs:{"id":"launch-btn","appid":"wx0ff59ec3274e0a53","extinfo":"id=2&pid=3"}},[_c('script',{attrs:{"type":"text/wxtag-template"}},[_vm._v(" <style> .btn{ color:red; } </style> <button class=\"btn\">按钮</button> ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }